import { Button, Col, Row } from 'antd';
import React, { Fragment, useEffect, useState } from 'react';
import SignaturePadComponent from './SignaturePadComponent';
import SignatureVerificationModal from './modals/SignatureVerificationModal';
import SIgnatureAcknowledgment from './SIgnatureAcknowledgment';
import { useLocation } from 'react-router-dom';
import { ServerAPI } from '../../common/ServerAPI';
import { toast } from 'react-toastify';

const RemoteSign = () => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const [verifyModal, setVerifyModal] = useState(false);
    const [nricVerification, setNricVerification] = useState(false);
    const [holderName, setHolderName] = useState("");


    const NRICVerifier = async (value) => {
        if (value) {
            const response = await (ServerAPI.nricVerifier(value));
            if (response) {
                setNricVerification(true);
            }else{
                toast.error("NRIC not Matched");
                setVerifyModal(true);
            }
        }
    }
    useEffect(() => {
        setVerifyModal(true);
    }, [])

    useEffect(() => {
        if (queryParams) {
            if (queryParams.get('holderType')) {
                localStorage.setItem('holderType', queryParams.get('holderType'));
            }
            if (queryParams.get('applicantionId')) {
                localStorage.setItem('applicationno', queryParams.get('applicantionId'));
            }
            if (queryParams.get('holderType')) {
                localStorage.setItem('holderType', queryParams.get('holderType'));
            }
            if (queryParams.get('holdername')) {
                setHolderName(queryParams.get('holdername'));
                localStorage.setItem('holdername', queryParams.get('holdername'));
            }
            if (queryParams.get('holderId')) {
                localStorage.setItem('holderId', queryParams.get('holderId'));
            }
        }
    }, [queryParams])
    return (
        <div className='w-screen'>
            {nricVerification == true &&
                <Fragment>
                    <p>{nricVerification}</p>
                    <SIgnatureAcknowledgment />
                </Fragment>
            }

            <SignatureVerificationModal open={verifyModal} close={() => { setVerifyModal(false) }} name={holderName} verifierFunction={NRICVerifier} />
        </div >
    );
};

export default RemoteSign;